import React from "react";

const Walletfalse = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M4.989 7h24.009V2.5a.498.498 0 00-.584-.493l-23.51 4a.5.5 0 00-.416.492v.592c.16-.059.33-.09.5-.092zM25.497 12.998h6.502V8.5a.5.5 0 00-.5-.5H4.989a.5.5 0 00-.5.5v13.398a7.033 7.033 0 019.606 2.582 7.022 7.022 0 01.937 3.517c0 .17-.014.334-.026.5H31.5a.5.5 0 00.5-.5v-5h-6.502a1.501 1.501 0 01-1.5-1.499v-6.999a1.5 1.5 0 011.5-1.5zm3.501-3h.5a.5.5 0 010 1h-.5a.5.5 0 110-1zm-2 0h.5a.5.5 0 010 1h-.5a.5.5 0 110-1zm-2.002 0h.5a.5.5 0 010 1h-.5a.5.5 0 110-1zm-8.503 16.498h-.5a.5.5 0 110-1h.5a.5.5 0 010 1zm2 0h-.5a.5.5 0 110-1h.5a.5.5 0 010 1zm2.002 0h-.5a.5.5 0 110-1h.5a.5.5 0 010 1z"
            fill={fill}
        />
        <path className="u_fill" d="M29.498 18.498a.5.5 0 100-1 .5.5 0 000 1z" fill={fill} />
        <path
            className="u_fill"
            d="M33.5 13.998h-8.003a.5.5 0 00-.5.5v7a.5.5 0 00.5.499H33.5a.5.5 0 00.5-.5v-6.999a.5.5 0 00-.5-.5zm-4.002 5.5a1.501 1.501 0 01-1.06-2.56 1.502 1.502 0 012.56 1.06 1.5 1.5 0 01-1.5 1.5zM10.343 29.647a.503.503 0 01.115.549.499.499 0 01-.823.158l-1.647-1.646-1.647 1.646a.5.5 0 01-.707-.707l1.647-1.646-1.647-1.646a.5.5 0 01.707-.707l1.647 1.646 1.647-1.646a.5.5 0 01.708.707L8.696 28l1.647 1.646zm-2.348-7.631a5.998 5.998 0 00-5.539 3.699 5.99 5.99 0 004.37 8.17 5.999 5.999 0 006.154-2.548 5.99 5.99 0 001.01-3.33 5.997 5.997 0 00-5.995-5.991z"
            fill={fill}
        />
    </svg>
);

export default Walletfalse;
